import Icon from '../components/Icon.vue'

Icon.register({
  'meh-rolling-eyes': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM88 224c0 35.3 28.7 64 64 64s64-28.7 64-64c0-24.3-13.7-45.2-33.6-56 0.7 2.6 1.6 5.2 1.6 8 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.8 0.9-5.4 1.6-8-19.9 10.8-33.6 31.7-33.6 56zM312 400c21.2 0 21.2-32 0-32h-128c-21.2 0-21.2 32 0 32h128zM344 288c35.3 0 64-28.7 64-64 0-24.3-13.7-45.2-33.6-56 0.7 2.6 1.6 5.2 1.6 8 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.8 0.9-5.4 1.6-8-19.9 10.8-33.6 31.7-33.6 56 0 35.3 28.7 64 64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meh-rolling-eyes.js
// module id = 1557
// module chunks = 0